<!-- 图片上传 -->
<template>
  <div>
    <transition name="el-zoom-in-bottom">
      <div class="box" v-if="isBoxShow">
        <!-- 顶部盒子 -->
        <div class="top">
          <p ref="pRefs">上传进度</p>
          <h3><span class="uploadtext" style="color:green;">{{ successList.length }}
            </span>个图片上传成功 <span class="uploadtext" style="color:red;">{{ errorList.length }}
            </span>个图片上传失败</h3>
          <div class="top-r">
            <!-- <el-button style="width: 121px; height: 46px;margin-left:30px">确定上传</el-button> -->
            <!-- <div class="less" @click="$emit('isLessShowClick', false, true)">
              <i class="el-icon-minus"></i>
            </div> -->
            <div class="cross" @click="cross"><i class="el-icon-circle-close"></i></div>
          </div>
        </div>

        <!-- 中间部分 -->
        <div class="middle">
          <button class="btn" @click="onBtn">+选择图片</button>
          <el-upload ref="uploadFile" class="upload-demo" name='MultipartFile' :headers='config' :action="action"
            :data='query' :before-upload="onBeforeUpload" :on-preview="handlePreview" :on-remove="handleRemove"
            :on-success="handleSuccess" :on-progress="handleProgress" :on-change='onChange' :on-error="handleError"
            :file-list="fileList" list-type="picture" :multiple='true' :auto-upload="false" :show-file-list='false'>
            <el-button ref="uploadRef" size="small" type="primary"></el-button>
            <div slot="tip" class="el-upload__tip">
              <h3>请注意！</h3>
              <p>1.请确认您拥有上传图片的著作权或版权，如有侵权行为，您将承担相应的法律责任。</p>
              <p> 2.图片分辨率≥200w像素（画幅宽度*高度）；单个文件≤50M,格式限JPG、JPEG、GIF、PNG。</p>
              <div>

              </div>

            </div>
          </el-upload>
          <div class="file-list">
            <div class="file-item" v-for="(item, index) in fileUploadList" :key="index">
              <img :src="item.resUrl + '?x-oss-process=image/resize,h_300'" alt="">
              <!-- <img :src="item.file.url" alt=""> -->
              <div class="del" @click="delFile(index)">
                <i class="el-icon-circle-close"></i>
              </div>
              <div class="file-name">{{ item.file.name }}</div>
              <div class="file-size">{{ (item.file.size / 1024 / 1024).toFixed(2) }}MB</div>
              <div class="file-state"
                :style="{ color: item.state == 'success' ? 'green' : item.state == 'error' ? 'red' : '' }">{{

                  item.state == 'await' ? '待上传' : item.state == 'padding' ? '正在上传...' : item.state == 'success' ? '上传成功'
                    :
                    '上传失败'
                }}
                <i v-if="item.state == 'padding'" class="el-icon-loading"></i>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部 -->
        <div class="foot">
          <!-- <el-button @click="clear">清空上传失败项</el-button> -->
          <el-button v-if="fileUploadList.length && isUploadSuccess" class="okUpload" @click="okUpload">确认上传</el-button>
          <!-- <div style="width:146px;height:42px"></div> -->

          <!-- <el-button
            ref="btnEditRef"
            style="background-color:#ccc;color:#fff;"
            disabled
                                              >去编辑图片11</el-button> -->

        </div>
      </div>
    </transition>
    <!-- 最小化 -->
    <transition name="el-zoom-in-bottom">
      <!-- <div class="box2" v-show="isLessShow">
        <el-button>＋选择图片</el-button>
        <div class="right">
          <div class="big" @click="$emit('isBigShowClick', false, true)"><i class="el-icon-copy-document"></i></div>
          <div class="cross" @click="cross"><i class="el-icon-circle-close"></i></div>
        </div>
      </div> -->
    </transition>
  </div>
</template>

<script>
import axios from '@/utils/axios'
import { uploadPhoto } from '@/api/upload.js'
import qs from 'qs'
export default {
  props: {
    isBoxShow: {
      type: Boolean,
      required: true,
    },
    isLessShow: {
      type: Boolean,
      required: true,
    },
    feedType: {
      type: Number,
      required: true
    },
  },
  created() {

    this.token = window.localStorage.getItem('token')
    // console.log(this.token);
    // console.log(this.query);
  },
  data() {
    return {
      successLength: 0, //上传成功个数
      regLength: 0,//上传失败个数
      fileList: [],
      token: null,
      isFileShow: false,
      // action: "http://yun.yunshangzg.com:1008/upload/uploadPhoto",
      action: `${axios.defaults.baseURL}/upload/uploadPhoto`,
      //接口参数
      query: {
        file: null,
        feedType: null
      },
      goEdit: true,    //控制去编辑按钮禁用
      successList: [],//上传成功的列表
      errorList: [],//上传失败的列表
      fileUploadList: [],
    }
  },
  mounted() {
  },
  methods: {
    cross() {
      this.$emit('update:isBoxShow', false)
      // 去编辑图片按钮的显示隐藏
      this.$emit("yeye", false)
    },
    // 自己定位一个按钮，把上传按钮覆盖，通过ref触发上传按钮（通过有无token判断）
    // 因为el-upload的上传按钮会自己打开本地文件选择器
    onBtn() {
      if (this.token) {
        this.fileUploadList = []
        this.successList = []
        this.errorList = []
        this.$refs.uploadRef.$el.click()
      } else {
        return this.$message.error('请先登录')
      }
    },

    async okUpload() {
      // console.log(this.fileUploadList);
      // // 上传文件要使用FormData形式
      // const formData = new FormData()
      // this.fileUploadList.forEach(async (file) => {
      //   formData.append('file', file.file.raw, file.file.name)
      //   file.state = '上传中..'
      //   await uploadFreePhoto(formData)
      //   file.state = '上传完成'
      // })
      this.isUploadSuccess = false
      console.log('正在上传');
      for (const file of this.fileUploadList) {
        try {
          file.state = 'padding'
          const formData = new FormData()
          formData.append('file', file.file.raw, file.file.name)
          formData.append('feedType', this.query.feedType)
          const res = await uploadPhoto(formData)
          if (res.success) {
            file.state = 'success'
            file.resUrl = res.data[0]
            // 成功列表
            this.successList = this.fileUploadList.filter(item => {
              return item.state == 'success'
            })
            console.log('接口调用成功:',);
            console.log(this.fileUploadList);
          } else {
            // 失败列表
            this.errorList = this.fileUploadList.filter(item => {
              return item.state == 'error'
            })
          }
        } catch (error) {
          console.error('接口调用失败:', error);
          // break; // 可根据需求决定是否继续后续调用
        }
      }
      console.log('所有接口调用完成');
      // const res = await uploadFreePhoto(formData)
      this.isUploadSuccess = true
    },
    delFile(index) {
      this.fileUploadList.splice(index, 1);
    },
    onChange(file, fileList) {
      console.log(file);
      //       this.query.file = file.raw
      //       this.fileList = fileList
      const types = ['image/jpeg', 'image/jpg', 'image/gif', 'image/png']
      if (!types.includes(file.raw.type)) {
        this.$message.error('您上传的图片格式不正确')
        return false
      }
      const maxSize = 50 * 1024 * 1024
      if (file.raw.size > maxSize) {
        this.$message.error('您上传的图片大小在50MB以内')
        return false
      }
      if (this.fileUploadList.length > 100) {
        this.$message.error('一次上传不能超过100张')
        return false
      } else {
        this.fileUploadList.push({
          file: file,
          state: 'await',
          resUrl: 'https://img.yunshangzg.com/yssj/commodityPhoto/20250714/L11Y95KA.png'
        })
        this.isUploadSuccess = true
        // console.log('onBeforeUpload', this.fileUploadList.length);
      }
    },

    onBeforeUpload(file) {
      // this.query.file = file
      console.log(file)

      const types = ['image/jpeg', 'image/jpg', 'image/gif', 'image/png']
      if (!types.includes(file.type)) {
        this.$message.error('您上传的图片格式不正确')
        return false
      }
      const maxSize = 50 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.error('您上传的图片大小在50MB以内')
        return false
      }
    },

    // async httpRequest (file) {
    //   this.query.file = file
    //   const formdata = new FormData
    //   let files = file.file
    //   console.log('files', files);
    //   formdata.append('file', files)
    //   formdata.append('feedType', 3)
    //   console.log(formdata.get("feedType"))
    //   const res = await this.$axios.post('/upload/uploadPhoto', {
    //     ...this.query
    //   })
    //   console.log(res);
    // },

    // onChange(file, fileList) {
    //   this.query.file = file.raw
    //   this.fileList = fileList;

    // },


    handleRemove(file, fileList) {
      this.fileList = fileList;
      // console.log(file);
      // 成功列表
      this.successList = fileList.filter(item => {
        return item.response.success == true
      })
      // 失败列表
      this.errorList = fileList.filter(item => {
        return item.response.success == false
      })
    },
    handlePreview(file, fileList) {
      // console.log(file);
      // console.log(fileList);
    },
    // 文件上传时的钩子
    handleProgress(event, file, fileList) {
      this.$refs.pRefs.innerHTML = '<div >上传中...</div>'
      this.fileList = fileList
    },
    // 上传失败的钩子
    handleError(err, file, fileList) {
      // console.log(err);

      // this.$refs.uploadFile.clearFiles()
    },
    handleSuccess(response, file, fileList) {
      this.$refs.pRefs.innerHTML = '<div style="color:#09BA07;">上传完成</div>'


      if (file) {
        // 上传成功的文件列表
        if (file.response.success == true) {
          file.name += '上传成功'
        }
        // 上传失败的文件列表
        if (file.response.success == !true) {
          file.name += file.response.msg
        }
      }


      // 成功列表
      this.successList = fileList.filter(item => {
        return item.response.success == true
      })
      // 失败列表
      this.errorList = fileList.filter(item => {
        return item.response.success == false
      })

      // 如果成功列表长度大于一就解除按钮禁用
      if (this.successList.length > 0) {
        this.goEdit = false
      }


      this.fileList = fileList
    },
    clear() {
      // 删除上传失败的项
      // console.log(this.fileList);
      const newFileList = this.fileList.filter(item => {
        return item.response.success == true
      })
      // console.log(newFileList);
      this.fileList = newFileList
    },
    // 点击去编辑照片
    goEditImg() {
      // 按钮不在这
      // this.$bus.$emit("data", 'img');
    }
  },
  computed: {
    config() {
      return { token: this.token };
    },
  },
  watch: {
    //监听父组件传过来的feedType变化，子组件跟着变化
    feedType: {
      handler(newVal) {
        // console.log(newVal)
        this.query.feedType = newVal
      },
      immediate: true,
    }

  },
  filters: {},
  components: {}
}
</script>

<style scoped lang='scss'>
.okUpload {
  font-size: 13px !important;
  padding: 6px 10px;
  background-color: #db3a3b;
  color: #fff;
  border-radius: 5px;

}

.file-list {
  width: 100%;
  padding: 10px 0;
  overflow: auto;
  height: 350px;

  .file-item {
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 10px;
    font-size: 13px;
    color: #666;
    margin-bottom: 12px;
    position: relative;

    .del {
      position: absolute;
      top: 0;
      right: 0;
    }

    img {
      width: 60px;
      height: 60px;
      object-fit: cover;
      margin-right: 20px;
    }

    .file-name {
      margin-right: 30px;
      width: 300px;
      white-space: nowrap;
      /* 确保文本在一行内显示 */
      overflow: hidden;
      /* 隐藏超出容器宽度的文本 */
      text-overflow: ellipsis;
      /* 使用省略号表示文本已被截断 */
    }

    .file-size {
      margin-right: 30px;
    }
  }
}

// 按钮禁用
.diabled {
  background-color: #ccc !important;
}

//上传结果文字
.uploadtext {
  font-size: 18px !important;
  font-weight: 600 !important;
}

.box {
  width: 720px;
  height: 700px;
  border-radius: 20px 0 0 0;
  background-color: #fff;
  color: #333;
  position: fixed;
  bottom: 40px;
  right: 0;
  z-index: 1111;

  .top {
    height: 80px;
    margin: 0 18px;
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      text-align: center;
      line-height: 22px;
      width: 64px;
      height: 22px;
      margin-right: -60px;
      font-size: 16px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #000000;
    }

    h3 {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      letter-spacing: 0px;
      color: #666;
      margin-left: -100px;
    }

    .top-r {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .el-button {
        width: 121px;
        height: 46px;
        margin-right: 30px;
        margin-top: 4px;
        background-color: #db3a3b;
        color: #fff;
        border-radius: 5px;
        text-align: center;
      }

      .less {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }

      .cross {
        width: 20px;
        height: 20px;
      }
    }
  }

  // 中间样式
  .middle {
    width: 720px;
    height: 540px;
    padding: 0 20px;
    position: relative;

    .btn {
      position: absolute;
      top: -62px;
      left: 500px;
      width: 101px;
      height: 40px;
      margin-right: 30px;
      background-color: #db3a3b;
      color: #fff;
      border-radius: 5px;
      z-index: 99999;
      font-size: 13px;
    }

    .el-button {
      opacity: 0;
      position: absolute;
      top: -62px;
      left: 502px;
      width: 21px;
      height: 16px;
      margin-right: 30px;
      background-color: #db3a3b;
      color: #fff;
      font-size: 14px;
    }

    .el-upload__tip {
      height: 90px;
      border-bottom: 1px solid #ccc;

      h3 {
        font-size: 14px;
        color: #e73d4a;
      }

      p {
        margin-top: 5px;
        color: #808080;
      }
    }
  }

  // 底部
  .foot {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 720px;
    height: 80px;
    border-top: 1px solid #ccc;

    // background-color: red;
    .el-button {
      height: 42px;
      width: 146px;

      &:nth-child(1) {

        &:focus,
        &:hover {
          color: #606266 !important;
          border-color: #ccc;
          background-color: #fff;
        }
      }

      &:nth-child(2) {
        background-color: #db3a3b;
        color: #fff;
        font-size: 14px;
      }
    }
  }
}

// 给upload组件list设置滚动条
/deep/ .el-upload-list {
  overflow-y: auto;
  width: 700px;
  height: 400px;
}

// 最小化样式
.box2 {
  width: 720px;
  height: 150px;
  border-radius: 20px 0 0 0;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  position: fixed;
  bottom: 40px;
  right: 0;
  z-index: 1111;

  .right {
    display: flex;

    .big {
      margin-right: 20px;
    }
  }

  .el-button {
    width: 121px;
    height: 46px;
    margin-right: 30px;
    background-color: #db3a3b;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contributor/components/imgUpload.vue